import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import useStyles from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTheme } from "@material-ui/core/styles";
const DownloadETicket = ({voucher_url=''}) => {
  const theme = useTheme();
    const classes = useStyles();
    
    const onDownloadClick = (e, url = null) => {
      e.stopPropagation()
      if (!url) return;
      window.open(url)
    }  

    return(<Box mt={2}>
        <Card className={classes.paddedCards}>
        <CardContent style={{paddingTop: '12px'}}>
          <Box mb={1} display='flex' justifyContent='space-between' width='100%'>
            <Typography variant='subtitle1' className={classes.overviewText}>Download E-Ticket</Typography>
          </Box>
          <Divider />
          <Box mt={1.5} p={1} display="flex" flexDirection={'column'} maxWidth={'124px'} textAlign="center" justifyContent={'center'} alignItems={'center'}> 
            <GetAppIcon style={{color:theme?.agentTheme?.primary?.main,cursor:'pointer'}} onClick={(e) => onDownloadClick(e, voucher_url)} />
            <Typography style={{color:theme?.agentTheme?.primary?.main}}>E Ticket</Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>);
}

export default DownloadETicket;